import axios from 'axios';

export const uploadCondoDocument = async ({ id, data, newToken }) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/documents/${id}`,
      data,
      headers: {
        Authorization: newToken,
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const uploadCondoDocumentRASZip = async ({ id, data, newToken }) => {
  try {
    const combinedFormData = new FormData();

    data.forEach((formData, index) => {
      for (let [key, value] of formData.entries()) {
        combinedFormData.append(`${key}_${index}`, value);
      }
    });

    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/documents/${id}/ras-zip`,
      data: combinedFormData,
      headers: {
        Authorization: newToken,
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};
